import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { ToasterService } from '@mars/ui-components';
import { AuthService } from '../services/auth/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToasterService);

  const handleLoggingOut = (errorMessage: string) => {
    toastService.add('', errorMessage, 'assets/icons/danger.svg', 'error');
    authService.logoutAction();
  };

  return next(req).pipe(
    catchError((httpError: HttpErrorResponse) => {
      const error = httpError.error;
      if (httpError.status == 401 || httpError.status == 500) {
        handleLoggingOut(error.message);
      } else if (httpError.status == 403) {
        toastService.add('', error.message, 'assets/icons/danger.svg', 'error');
      } else if (httpError.status != 422) {
        toastService.add(
          '',
          error.message,
          'assets/icons/danger.svg',
          'error',
          true,
          false
        );
      }
      return throwError(() => error);
    })
  );
};
